import {
	Category as CategoryIcon,
	FilterList as FilterListIcon,
	Groups as GroupsIcon,
	Inventory2 as Inventory2Icon,
	LocalOffer as LocalOfferIcon,
} from "@mui/icons-material";
import React from "react";
import DashboardGuidedTour from "./DashboardGuidedTour";

/**
 * Supply Type Allocation Dashboard guided tour.
 *
 * Thin configuration wrapper around the reusable {@link DashboardGuidedTour}
 * component, which provides the shared Welcome screen, dark-navy tooltip,
 * progress bar, overlay and Previous / Next / Skip Tour / Pause / Close
 * behaviour (the same architecture built for the Vehicle Tracking dashboard).
 *
 * Flow: Welcome screen -> NEXT -> Total Parts -> Purchase Types -> SE Teams ->
 * Filters -> Complete.
 */
const WELCOME = {
	icon: <CategoryIcon sx={{ color: "#cc0000" }} />,
	title: "Supply Type Allocation Tour",
	description:
		"Welcome to the Supply Type Allocation dashboard - your tool for monitoring and managing supply type allocation across parts, projects, programs, purchase types, teams, and categories.",
	footer:
		"This tour will guide you through all key features in about 2 minutes.",
	chips: [
		{
			icon: <FilterListIcon />,
			label: "Advanced Filtering", 
			bgcolor: "#e3f2fd",
		},
		{ icon: <LocalOfferIcon />, label: "Purchase Types", bgcolor: "#e8f5e8" },
		{ icon: <GroupsIcon />, label: "SE Teams", bgcolor: "#fff3e0" },
		{ icon: <Inventory2Icon />, label: "Parts Overview", bgcolor: "#fce4ec" },
	],
};

const STEPS = [
	{
		target: '[data-tour-target="sta-dash-total-parts"]',
		icon: <Inventory2Icon sx={{ color: "#cc0000" }} />,
		title: "Total Parts",
		description:
			"Shows the total number of parts available in the tracking system.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="sta-dash-purchase-types"]',
		icon: <LocalOfferIcon sx={{ color: "#cc0000" }} />,
		title: "Purchase Types",
		description:
			"Shows the number of different purchase types available in the tracking system.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="sta-dash-se-teams"]',
		icon: <GroupsIcon sx={{ color: "#cc0000" }} />,
		title: "SE Teams",
		description: "Shows the total number of SE teams in the tracking system.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="sta-dash-filters"]',
		icon: <FilterListIcon sx={{ color: "#cc0000" }} />,
		title: "Filters",
		description:
			"Use these filters to narrow down the supply type allocation data. Reset clears the selected filters and Apply updates the results.",
		extra: {
			heading: "Filter Options:",
			text: "• Projects • Programs • Purchase Types • Teams • Category • Reset • Apply",
		},
		placement: "bottom-end",
	},
];

const SupplyTypeAllocationDashboardJoyrideTour = ({ isOpen, onClose }) => (
	<DashboardGuidedTour
		isOpen={isOpen}
		onClose={onClose}
		tourTitle="Supply Type Allocation Tour"
		welcome={WELCOME}
		steps={STEPS}
	/>
);

export default SupplyTypeAllocationDashboardJoyrideTour;
